import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "process",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        // const reducer = module.default;
        // const key = module.NAME;
        // injectReducer(store, {
        //   key,
        //   reducer,
        // });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  //   childRoutes: [SyncSetup(store)],
});
